import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#fafbfc]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 flex items-center justify-between h-16">
          <a href="/" className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Altrunic" className="w-8 h-8 object-contain" />
            <span className="text-lg font-bold tracking-tight text-gray-900">Altrunic</span>
          </a>
          <button onClick={() => navigate('/')} className="text-sm font-semibold text-gray-600 hover:text-gray-900">Home</button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-8" data-testid="privacy-title">Privacy Policy</h1>
        <div className="prose prose-gray max-w-none space-y-6 text-sm text-gray-600 leading-relaxed">
          <p><strong>Last updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">1. Information We Collect</h2>
          <p>We collect information you provide when creating an account, including your name, work email address, company name, and company size. When you make a donation, payment is processed through Every.org — we do not store credit card or bank information.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">2. How We Use Your Information</h2>
          <p>We use your information to: operate and improve the platform; process and track donations; generate impact reports and analytics; send transactional emails (verification, receipts, campaign updates); and provide customer support via our AI assistant.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">3. Data Sharing</h2>
          <p>We do not sell your personal information. We share data only with: Every.org (to process donations); Resend (to deliver transactional emails); and your employer (if you use the employee giving portal, only donation amounts and charity choices are shared with your company admin).</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">4. Data Security</h2>
          <p>Passwords are hashed using bcrypt. Sessions use secure, httpOnly cookies. All data is transmitted over HTTPS. We implement rate limiting to prevent abuse.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">5. Cookies</h2>
          <p>We use essential cookies for authentication sessions. We do not use tracking or advertising cookies.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">6. Your Rights</h2>
          <p>You may request to access, correct, or delete your personal data at any time by contacting support@altrunic.com. You may also delete your account from your profile settings.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">7. Changes to This Policy</h2>
          <p>We may update this policy from time to time. We will notify registered users of significant changes via email.</p>

          <h2 className="text-lg font-bold text-gray-900 mt-8">8. Contact</h2>
          <p>For privacy inquiries, contact us at <a href="mailto:support@altrunic.com" className="text-blue-600 hover:underline">support@altrunic.com</a>.</p>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
